module.exports = __webpack_public_path__ + "media/images/flags/cn-2c53123099f8c2ce8b95c419108d0b98.svg";